import { logger } from '@adornis/base/logging.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Submission } from '../submission.js';

export const updateGrammarErrorMutation = registerMutation({
  operationName: 'updateGrammarErrorMutation',
  type: () => Boolean,
  params: [
    { name: 'submissionId', type: () => String },
    { name: 'mainTaskId', type: () => String },
    { name: 'errorId', type: () => String },
    { name: 'category', type: () => String },
    { name: 'message', type: () => String },
    { name: 'boxX', type: () => Float },
    { name: 'boxY', type: () => Float },
    { name: 'boxWidth', type: () => Float },
    { name: 'boxHeight', type: () => Float },
    { name: 'boxPage', type: () => Float },
  ],
  resolve: (
    submissionId: string,
    mainTaskId: string,
    errorId: string,
    category: string,
    message: string,
    boxX: number,
    boxY: number,
    boxWidth: number,
    boxHeight: number,
    boxPage: number,
  ) =>
    async () => {
      try {
        const col = await getRawCollection(Submission._collectionName);
        const submission = await col.findOne({ _id: submissionId } as any);
        if (!submission) return false;

        const mainTaskIndex = (submission as any).taskSubmissions?.findIndex(
          (t: any) => String(t._id) === String(mainTaskId),
        );
        if (mainTaskIndex === undefined || mainTaskIndex === -1) return false;

        const path = `taskSubmissions.${mainTaskIndex}.grammarEvaluation`;

        await (col as any).updateOne(
          { _id: submissionId },
          {
            $set: {
              [`${path}.errors.$[elem].category`]: category,
              [`${path}.errors.$[elem].message`]: message,
              [`${path}.errors.$[elem].boundingBox.topLeft.x`]: boxX * 10,
              [`${path}.errors.$[elem].boundingBox.topLeft.y`]: boxY * 10,
              [`${path}.errors.$[elem].boundingBox.bottomRight.x`]: (boxX + boxWidth) * 10,
              [`${path}.errors.$[elem].boundingBox.bottomRight.y`]: (boxY + boxHeight) * 10,
              [`${path}.errors.$[elem].boundingBox.pageNumber`]: boxPage + 1,
            },
          },
          { arrayFilters: [{ 'elem._id': errorId }] },
        );

        return true;
      } catch (err) {
        logger.error(
          { err, submissionId, mainTaskId, errorId, context: 'UPDATE_GRAMMAR_ERROR' },
          'Failed to update grammar error',
        );
        return false;
      }
    },
});
